export enum EnumPaymentCycleStatus {
  IN_PROGRESS = "IN_PROGRESS",
  CLOSED = "CLOSED",
}
